/** Holds the runtime config loaded from /env-config.json */
let _config: AppRuntimeConfig | null = null;

export async function loadRuntimeConfig(): Promise<void> {
  if (import.meta.env.MODE === 'development') {
    // In local dev, read from Vite env vars defined in .env.local
    _config = {
      apiUrl: import.meta.env.VITE_API_URL ?? 'http://localhost:3000',
      userPoolId: import.meta.env.VITE_USER_POOL_ID ?? '',
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID ?? '',
      cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN ?? '',
      appUrl: 'http://localhost:5173',
    };
    return;
  }

  const response = await fetch('/env-config.json');
  if (!response.ok) {
    throw new Error('Failed to load runtime configuration. Please contact your administrator.');
  }
  _config = (await response.json()) as AppRuntimeConfig;
}

export function getRuntimeConfig(): AppRuntimeConfig {
  if (!_config) {
    throw new Error('Runtime configuration has not been loaded. Call loadRuntimeConfig() first.');
  }
  return _config;
}
